import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "ver" }
const _hoisted_3 = { class: "web-part" }
const _hoisted_4 = {
  key: 0,
  class: "other-info"
}

import { showUserServiceDialogue } from "@/components/Dialogues/useData/useDialogues";
import { AppConfig } from "@/utils/constant";
import {
  openPrivacy,
  openAgreement,
} from "@/components/Dialogues/useData/login";

export default /*@__PURE__*/_defineComponent({
  __name: 'UserServiceDialogue',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(showUserServiceDialogue),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showUserServiceDialogue) ? (showUserServiceDialogue).value = $event : null)),
    width: "400",
    class: "custom",
    "align-center": "",
    center: "",
    style: { '--el-border-radius-base': '8px' }
  }, {
    header: _withCtx(() => _cache[3] || (_cache[3] = [])),
    footer: _withCtx(() => [
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[8] || (_cache[8] = [
            _createTextVNode(" © 2024 深圳市超时代软件有限公司版权所有 网信算备440305487056801240029号 "),
            _createElementVNode("a", {
              "data-v-37865364": "",
              href: "https://beian.miit.gov.cn",
              target: "_blank",
              class: "link ml-4",
              style: {"color":"#aaa","font-size":"12px","text-decoration":"none"}
            }, "粤ICP备05021908号", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, "关于我们", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("img", {
          src: _imports_0,
          class: "logo"
        }, null, -1)),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "name" }, "超时代AI", -1)),
        _createElementVNode("div", _hoisted_2, "版本号 " + _toDisplayString(_unref(AppConfig).curr_ver), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openAgreement) && _unref(openAgreement)(...args)))
          }, "用户协议"),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "v-divider" }, null, -1)),
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(openPrivacy) && _unref(openPrivacy)(...args)))
          }, "隐私协议")
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})